import React, { useState } from 'react';
import {
  IonPage,
  IonContent,
  IonCard,
  IonCardContent,
  IonButton,
  IonIcon,
  IonText,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  useIonViewWillEnter,
  IonRefresher,
  IonRefresherContent,
  RefresherCustomEvent,
  useIonAlert,
  useIonRouter,
} from '@ionic/react';
import { timeOutline, person, call, remove} from 'ionicons/icons';
import MsgIcon from '../../../shared/assets/icons/msg.svg';
import CoinIcon from '../../../shared/assets/icons/storage.svg';
import LogoutIcon from '../../../shared/assets/icons/logout.svg';
import DishIcon from '../../../shared/assets/icons/dish.svg';
import './Orders.css';
import { ordersPickupDelivery } from '../../../entities/orders-pickup-delivery';
import { Order } from '../../../entities/orders-pickup-delivery/models/types';
import { updateOrderStatus } from '../../../entities/update-order-status';
import { OrdersPageSkeleton } from '../../../components/OrdersPageSkeleton';



const Orders: React.FC = () => {
  const [presentAlert] = useIonAlert();
  const router = useIonRouter()
  const [isLoading,setLoading] = useState(true)
  const [orders,setOrders] = useState<Order[]>([])
  // const [newOrders,set]
  const handleConfirm = async (orderId:any,status:any)=>{
    try {
      const params = {
        status: status,
        notes: "Order started cooking"
      }
      const res = await updateOrderStatus(orderId,params)
      deliveryPickupOrders()
    } catch (error) {
      console.log(error)
    }
  }
  const handleCancle = async (orderId: any) => {
    try {
      const params = {
        status: "canceled",
        notes: "Order started cooking"
      }
      const res = await updateOrderStatus(orderId, params)
    } catch (error) {
      console.log(error)
    }
  }
  const deliveryPickupOrders = async ()=>{
    try {
       setLoading(true);
      const res = await ordersPickupDelivery()
      setOrders(res)
      // console.log(order)
      console.log(res.filter(el=>el.status=='preparing').length)
    } catch (error) {
      console.log(error)
    }finally{
       setLoading(false);
    }
  }
  function handleRefresh(event: RefresherCustomEvent) {
    setTimeout(() => {
      deliveryPickupOrders()
      event.detail.complete();
    }, 2000);
  }
  const showCode = (code:any,number:any)=>{
    presentAlert({
      subHeader:'Заказ #'+number,
      message: code,
    })
  }
  useIonViewWillEnter(()=>{
    deliveryPickupOrders()
  },[deliveryPickupOrders])
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonIcon icon={DishIcon} className=" ml-2 mr-2 h-[30px]"/>
            <IonText className="!text-[#000]">Waiter App</IonText>
          </IonButtons>
          <IonButtons slot='end'>
            <IonButton>Online</IonButton>
            <IonButton><IonIcon icon={LogoutIcon}/></IonButton>
          </IonButtons>
        </IonToolbar>
        
      </IonHeader>
      <IonContent fullscreen className="orders-content ">
        {isLoading ? <OrdersPageSkeleton count={10} />:
        <>
        <IonRefresher slot="fixed" pullFactor={0.5} pullMin={100} pullMax={200} onIonRefresh={handleRefresh}>
          <IonRefresherContent className=""></IonRefresherContent>
        </IonRefresher>
        {orders.length ==0 ? <div className="flex items-center justify-center h-full"><p className="text-[16px] text-[#6B7280]">Нет заказов на доставку и самовывоз</p></div>:
        <div className="orders-wrapper px-3">
          <div className="orders-header">
            <h2>Заказы (доставка/самовывоз)</h2>
          </div>

          <div className="flex items-center justify-between ">
            <div className=" flex column items-center rounded-2xl justify-center bg-[#E5E7EB] h-[84px] w-[100px]">
              <div className='text-center px-2'>
                <div className="orders-stat-number text-[16px]">{orders.filter(el=>el.status=='pending').length}</div>
                <div className="orders-stat-label font-sm text-[14px]">Новые заказы</div>
              </div>
            </div>
            <div className="flex column items-center rounded-2xl justify-center  bg-[#f2c94c33] h-[84px]  w-[100px]">
              <div className='text-center px-2'>
                <div className="orders-stat-number text-[16px] text-[#F2C94C]">{orders.filter(el=>el.status=='preparing').length}</div>
                <div className="orders-stat-label font-sm text-[14px]">В процессе</div>
              </div>
            </div>
            <div className="flex column items-center rounded-2xl justify-center  bg-[#27ae6033] h-[84px]  w-[100px]">
               <div className='text-center px-2'>
                  <div className="orders-stat-number text-[16px] text-[#27AE60]">{orders.filter(el=>el.status=='ready').length}</div>
                  <div className="orders-stat-label font-sm text-[14px]">Готовы</div>
              </div>
            </div>
          </div>

          <div className="orders-list px-0">
            {orders?.map((order:any) => 
              (order.status !== "cancelled" && order.status !== "completed") && (
              <IonCard key={order.id} className="order-card px-0">
                <IonCardContent>
                  <div className="order-top-row">
                    <div className="order-id-time">
                      <span className=" font-bold text-[#000]">#{order.orderNumber}</span>
                      <span className="order-time">{new Date(order.createdAt).toLocaleTimeString("ru-RU", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}</span>
                    </div>

                    <div className="order-badges">
                      <span
                        className={
                          'order-badge px-5 py-3 flex items-center rounded-md text-[12px] ' +
                          (order.type === 'delivery'
                            ? 'badge-blue'
                            : 'badge-green')
                        }
                      >
                        {order.type === 'delivery' ? 'Доставка' : 'Самовывоз'}
                      </span>
                      <span
                        className={
                          'order-badge px-5 py-3 flex items-center rounded-md text-[12px] ' +
                          (order.status === 'pending'
                            ? 'badge-grey'
                            : order.status === 'preparing'
                            ? 'badge-yellow'
                            : 'badge-green')
                        }
                      >
                        {order.status === 'pending'
                          ? 'Новый'
                          : order.status === 'preparing'
                          ? 'Готовится'
                          : 'Готово'}
                      </span>
                    </div>
                  </div>

                  <div className="order-client">
                    <div className="order-client-row">
                      <IonIcon icon={person} className="text-[#9CA3AF]"  />
                      <span>{order.userName}</span>
                    </div>
                    <div className="order-client-row">
                      <IonIcon icon={call} className="text-[#9CA3AF]" />
                      <span>{order.userPhone}</span>
                    </div>
                    <div className="order-client-row">
                      <IonIcon icon={CoinIcon} className="h-[30px]" />
                    <IonText className="order-sum">{order.totalAmount}TJS</IonText>
                    </div>
                  </div>

                  <div className="order-items-box">
                    <div className="order-items-title">Состав заказа:</div>
                    {order.items.map((line:any, idx:any) => (
                      <div key={idx} className="order-item-line flex items-center">
                        {line.name}<IonIcon icon={remove} className="text-[#000]"></IonIcon>{line.quantity}шт
                      </div>
                    ))}
                  </div>
                  {order.status =='preparing' && 
                  <div className='mt-2'>
                    <div className='flex items-center'>
                      <IonIcon icon={timeOutline} className='mr-1' />
                      <span className='text-[14px]'>Будет готово через ≈ {order.remainingMinutes} минут</span>
                    </div>
                  </div>}

                  <div className="order-actions">
                    {order.status === 'pending' && (
                      <>
                        <IonButton className="rounded-xl  py-0 text-[#fff] bg-[#2F80ED]" onClick={()=>handleConfirm(order.id,'preparing')}>
                          Подтвердить
                         </IonButton>
                        <IonButton onClick={()=>handleCancle(order.id)}
                          className="!border !border-slate-400 py-0 !rounded-xl text-[#4B5563]"
                        >
                          Отменить
                        </IonButton>
                      </>
                    )}

                    {order.status === 'preparing' && (
                      <>
                       <IonButton className="bg-[#27AE60] rounded-xl px-4 py-0 text-[#fff] w-full"  onClick={()=>handleConfirm(order.id,'ready')} >
                        Готов к выдаче
                      </IonButton>
                       
                      </>
                     
                    )}

                    {order.status === 'ready' && (
                      <IonButton className="rounded-xl px-4 py-0  w-full border border-1 text-green-600 border-green-600">
                         {order.pickupCode}
                      </IonButton>
                    )}
                     {/* {order.status === 'preparing' && (
                      <>
                       <IonButton className="bg-[#27AE60] rounded-xl px-4 py-0 text-[#fff] w-full"  onClick={()=>handleConfirm(order.id,'ready')} >
                        {order.pickupCode}
                      </IonButton>
                       
                      </>
                     
                    )} */}

                     <IonButton className="!bg-[#E5E7EB] rounded-xl" onClick={()=>router.push(`/order-chat/${order.id}`)}>
                        <IonIcon src={MsgIcon} />
                      </IonButton>
                  </div>
                </IonCardContent>
              </IonCard>
            ))}
          </div>
        </div>}
        </>}
      </IonContent>
    </IonPage>
  );
};

export default Orders;
